import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Cloudflare Zero Trust callback route.
 *
 * After authenticating with Zero Trust, Cloudflare redirects to /cdn-cgi/access/authorized.
 * This route handles that callback by redirecting to the home page.
 *
 * The service worker is configured to exclude /cdn-cgi/* paths from caching,
 * so this route should only be hit after Zero Trust has set the access cookies.
 */
export const Route = createFileRoute('/cdn-cgi/access/authorized')({
  validateSearch: (search: Record<string, unknown>): { nonce?: string; state?: string } => ({
    nonce: typeof search.nonce === 'string' ? search.nonce : undefined,
    state: typeof search.state === 'string' ? search.state : undefined,
  }),
  component: CloudflareAccessAuthorized,
});

function CloudflareAccessAuthorized() {
  const navigate = useNavigate();

  useEffect(() => {
    // After Zero Trust authentication completes, redirect to home
    // The Zero Trust cookies should now be set, allowing access to the app
    void navigate({ to: '/', replace: true });
  }, [navigate]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <div>Completing authentication...</div>
    </div>
  );
}
